import { Id } from 'types';
import {
  Contract,
  ContractsApiResponse,
  ContractTerm,
  ContractFormValues,
  ContractTermPayload,
  SearchContracts,
} from 'pricing/types';
import { apiPostRequest, apiPutRequest, apiGetRequest } from 'utilities/http/api/apiHttp';
import { isEmpty } from 'lodash';
import { ContractListSearchState } from 'pricing/pages/contractList/ContractList.state';

export const apiContract = {
  getContract: (contractId: number) => {
    return apiGetRequest<{ contract: Contract }>(
      `breeder/contract/${contractId}`,
      'withTerms=true',
    );
  },

  postContract: (values: ContractFormValues) => {
    const payload = {
      contract: {
        startDate: values.startDate,
        endDate: values.endDate,
        breederContractConditionId: values.breederContractConditionId,
      },
    };
    return apiPostRequest<{ contract: Contract; message: string }>(
      `breeder/${values.breederId}/contract`,
      payload,
    );
  },

  putContract: (contractId: Id, values: Partial<Contract>) => {
    const payload = {
      contract: {
        ...values,
      },
    };
    return apiPutRequest<{ contract: Contract; message: string }>(
      `breeder/contract/${contractId}`,
      payload,
    );
  },

  postContractTerm: (
    contractId: Id,
    payload: { isAmendment: boolean; contractTerm: ContractTermPayload },
  ) => {
    return apiPostRequest<{ contractTerm: ContractTerm; message: string }>(
      `breeder/contract/${contractId}/term`,
      payload,
    );
  },

  putContractTerm: (
    contractTermId: number,
    payload: { isAmendment: boolean; contractTerm: ContractTermPayload },
  ) => {
    return apiPutRequest<{ contractTerm: ContractTerm; message: string }>(
      `breeder/contract/term/${contractTermId}`,
      payload,
    );
  },

  getContractsList: (values?: Partial<ContractListSearchState>) => {
    let parameters = `page_size=${values?.pagination?.pageSize || 25}&`;
    if (values?.filters) {
      for (const [key, value] of Object.entries(values?.filters)) {
        if ((value && key === 'color_ids') || (value && key === 'variety_ids')) {
          parameters += `filters[term][${key}][]=${value}&`;
        } else if (value) {
          parameters += `filters[term][${key}]=${value}&`;
        }
      }
    }

    if (values?.search) {
      for (const [key, value] of Object.entries(values?.search)) {
        if (value) {
          if (key === SearchContracts.ContractId) {
            parameters += `filters[contract][id]=${value}&`;
          } else {
            parameters += `filters[contract][${key}]=${value}&`;
          }
        }
      }
    }

    if (!isEmpty(values?.sort)) {
      if (values?.sort?.columnKey === 'breeder_name') {
        parameters += `order_by[][breeder_name]=${values?.sort?.order}&`;
      } else if (values?.sort?.columnKey === 'created_by') {
        parameters += `order_by[][created_by]=${values?.sort?.order}&`;
      } else {
        parameters += `order_by[][breeder_contracts.${values?.sort?.columnKey}]=${values?.sort?.order}&`;
      }
    }

    if (values?.pagination) {
      parameters += `page=${values?.pagination?.currentPage}&`;
    }

    return apiGetRequest<{ contracts: ContractsApiResponse }>(
      'breeder/contracts',
      parameters,
    );
  },
};
